// Wrapper around the two community surfaces (samples + songs) that
// gives the Community accordion section a Samples/Songs tab toggle.
//
// Keeps both children mounted under a CSS `hidden` so a tab switch
// doesn't drop their fetched data — the user toggling back & forth
// shouldn't trigger a refetch.

import { useState } from 'react';
import { CommunityLibrary } from './CommunityLibrary';
import { CommunityPatches } from './CommunityPatches';

export type CommunityTabsProps = {
  onStatus: (msg: string, level?: 'ok' | 'warn' | 'err' | '') => void;
  onForked: (params: { title: string; code: string; cloudPatchId: string }) => void;
  onPlayPatch: (params: { title: string; code: string; cloudPatchId: string }) => void;
};

type Tab = 'samples' | 'songs';

export function CommunityTabs({ onStatus, onForked, onPlayPatch }: CommunityTabsProps) {
  const [tab, setTab] = useState<Tab>('samples');

  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="flex gap-1 px-3 pt-2">
        <TabButton active={tab === 'samples'} onClick={() => setTab('samples')}>
          Samples
        </TabButton>
        <TabButton active={tab === 'songs'} onClick={() => setTab('songs')}>
          Songs
        </TabButton>
      </div>
      <div className="flex-1 min-h-0 relative">
        <div className={tab === 'samples' ? 'h-full' : 'hidden'}>
          <CommunityLibrary onStatus={onStatus} />
        </div>
        <div className={tab === 'songs' ? 'h-full' : 'hidden'}>
          <CommunityPatches
            onStatus={onStatus}
            onForked={onForked}
            onPlay={onPlayPatch}
          />
        </div>
      </div>
    </div>
  );
}

function TabButton({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={
        'text-[10px] uppercase tracking-[0.2em] px-2.5 py-1 border-b-2 transition-colors ' +
        (active
          ? 'border-cyan-300 text-cyan-300'
          : 'border-transparent text-zinc-500 hover:text-zinc-300')
      }
    >
      {children}
    </button>
  );
}
